export default { Admin: "Admin", SaaS: "SaaS",  СОSAAS : "СОSAAS", Rent: "Rent", CO: "CO", Multi: "Multi", None: "None"}